import { createFileRoute } from "@tanstack/react-router";
import { KnowledgePage } from "@client/components/kb/kb-page";

export const Route = createFileRoute("/_app/kb/")({
  component: KnowledgePage,
});
